import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, media, space } = theme

export const Hero = styled.section`
  position: relative;
  width: 100%;
  background-color: ${colors['neutral-background-default']};
  overflow: hidden;
  padding-bottom: ${space['spacing-mega']};

  @media (${media.tablet}) {
    padding-top: ${space['spacing-xxl']};
    padding-bottom: ${space['spacing-xxxl']};
  }
`

export const Content = styled.div`
  @media (${media.tablet}) {
    display: flex;
    flex-direction: row-reverse;
    gap: ${space['spacing-xxl']};
  }
`

export const ImgWrapper = styled.span`
  position: relative;
  width: 100%;
`

export const Infos = styled.div`
  margin-top: ${space['spacing-md']};

  h1,
  > p {
    margin-bottom: ${space['spacing-md']};
  }

  @media (${media.tablet}) {
    margin-top: 2.5rem;
    margin-bottom: 5.5rem;

    .ds-button {
      width: 19rem;
    }
  }

  @media (${media.desktop}) {
    margin-top: 6.5rem;

    h1 {
      margin-bottom: ${space['spacing-xl']};
    }

    > p {
      margin-bottom: ${space['spacing-lg']};
    }
  }
`
